import React from "react";
import { useTranslation } from "react-i18next";

function TopBar({ children, toggleLanguage }) {

  const { i18n } = useTranslation();
  return (
    <>
      <div className="topbar" style={{ backgroundColor: "#8ec0fc" }}>
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between">
            
            <div className="col text-center px-3 d-flex flex-start">
              <span
                className="mb-0"
                style={{
                  color: "#000",
                  fontSize: "100%",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontFamily: "Corrigan",
                }}
              >
                {localStorage.getItem("name")?.toUpperCase()}
              </span>
            </div>
            <div
              className="col-auto d-flex align-items-center"
              style={{ width: "160px", justifyContent: "space-between" }}
            >
              <span
                style={{
                  color: "#000",
                  background:
                    "linear-gradient(45deg, #000, #000, #000, #000)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "100%",
                }}
              >
                {i18n.language === "en" ? "Hebrew" : "Hebrew"}
              </span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={i18n.language === "he"}
                  onChange={toggleLanguage}
                />
                <span className="slider"></span>
              </label>

              {/* <img
                src={toggle ? "assets/toggle-on.png" : "assets/toggle-off.png"}
                height={40}
                width={40}
                className="me-3 mt-2"
                onClick={handleToggleClick}
                style={{ cursor: "pointer" }}
              />
              <img src="assets/edit.png" height={30} width={30} /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TopBar;
